import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

interface SiteColors {
  primary: string;
  primary_light: string;
  primary_dark: string;
  secondary: string;
}

export const useSiteColors = () => {
  const [colors, setColors] = useState<SiteColors>({
    primary: '#5D4037',
    primary_light: '#8D6E63',
    primary_dark: '#3E2723',
    secondary: '#EFEBE9',
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadColors();

    // الاستماع للتغييرات في الوقت الفعلي
    const subscription = supabase
      .channel('site_colors_changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'site_settings',
          filter: 'setting_key=eq.site_colors',
        },
        (payload) => {
          if (payload.new && (payload.new as any).setting_value) {
            setColors((payload.new as any).setting_value);
            applyColors((payload.new as any).setting_value);
          }
        }
      )
      .subscribe();

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  const loadColors = async () => {
    try {
      const { data } = await supabase
        .from('site_settings')
        .select('*')
        .eq('setting_key', 'site_colors')
        .maybeSingle();

      if (data?.setting_value) {
        setColors(data.setting_value);
        applyColors(data.setting_value);
      }
    } catch (error) {
      console.error('Error loading colors:', error);
    } finally {
      setLoading(false);
    }
  };

  const applyColors = (newColors: SiteColors) => {
    const root = document.documentElement;
    root.style.setProperty('--color-primary', newColors.primary);
    root.style.setProperty('--color-primary-light', newColors.primary_light);
    root.style.setProperty('--color-primary-dark', newColors.primary_dark);
    root.style.setProperty('--color-secondary', newColors.secondary);
  };

  return { colors, loading };
};
